export default __webpack_public_path__ + "static/media/ginger-root.f1dade3f.svg";